<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="420px">
      <div class="dialog-container">
        <div class="dialog-header flex-sb-center">
          <span>Upload</span>
          <i
            class="el-icon-close"
            @click="handleCancel"></i>
        </div>
        <div class="dialog-body">
          <section v-if="step==1">
            <p class="color-dark">Find a relevant document in reminder</p>
          </section>
          <template v-else>
            <el-form
              ref="form"
              :rules="rules"
              :model="formData">
              <div class="form-item">
                <el-form-item
                  ref="file_id"
                  prop="file_id"
                  :rules="rules.select"
                >
                  <v-radio-group
                    v-model="formData.file_id"
                    :value-key="'file_id'"
                    :list="file"
                  >
                    <template #default="{item}">
                      <span class="content-box">
                        <span class="flex-center mg-b-5">
                          <font-awesome-icon
                            class="fs-16 blue"
                            icon="file"></font-awesome-icon>
                          <span
                            class="blue mg-l-4 fs-14 fw-400 pointer block flex-1"
                            @click="openUrl(item.url)">{{renewFileTypeName[item.type]}}</span>
                        </span>
                        <span
                          class="doc-tips block flex-1 mg-b-5"
                          v-html="changeLineText(item.remark)">
                        </span>
                        <span class="flex-sb-center flex-1">
                          <span class="fs-12 fw-400 color-dark">{{item.created_date}}</span>
                          <span class="fs-12 name-content">{{item.cs_nm}}</span>
                        </span>
                      </span>
                    </template>
                  </v-radio-group>
                </el-form-item>
              </div>
            </el-form>
          </template>
        </div>
        <div class="dialog-footer">
          <div
            v-if="step==1"
            class="col">
            <v-button
              green
              class="width-fill mg-b-20"
              @click="handleSelectReminder">Select from reminder</v-button>
            <v-button
              gray
              class="width-fill mg-t-20"
              @click="handleUpload">Upload from computer</v-button>
          </div>
          <template v-if="step!=1">
            <v-button
              gray
              @click="handleCancel">Cancel</v-button>
            <v-button
              green
              @click="onContinue">Confirm</v-button>
          </template>
        </div>
      </div>
    </v-dialog>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {renewFileTypeName} from '@/utils/renew_type'
export default {
  name: 'upload-doc',
  mixins: [MixinOptions,MixinRules],
  props: {
    classId: {
      type: Number,
      default:14
    },
    file: {
      type: Array,
      default: () => ([])
    },
    fileList:{
      type: [Array,Object],
      default: ()=>[]
    },
    value:{
      type: Boolean,
      default: false
    },
    uploadData: {
      type: Object,
      default: () => ({})
    },
    isCompany: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialog: false,
      step:1,
      formData: {
        file_id:''
      },
    }
  },
  computed:{
    renewFileTypeName(){
      let type_name = renewFileTypeName
      if(this.isCompany)
        type_name.id_type_pic_path = 'Certificate of Incorporation/Business Registration Certificate'
      return type_name
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.dialog = val
      }
    },
  },
  methods: {
    handleUploadForm(uploadForm){
      this.$emit('uploadForm', uploadForm)
    },
    handleSelectReminder(){
      this.step  =2
    },
    handleUpload(){
      this.$emit('input',false)
      this.$emit('upload')
    },
    handleCancel() {
      this.$emit('input',false)
      this.step = 1
    },
    onContinue() {
      this.$refs['form'].validate((valid, rules) => {
        if(valid) {
          let {file_id} = this.formData||{}
          let obj = this.file.reduce((res,item)=>{
            if(item.file_id==file_id)
              res = item
            return res
          },{})
          this.$emit('uploadSuccess', obj)
          this.$emit('input',false)
          this.step  =1
        }
        else {
          console.log(rules)
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-dialog{
  box-sizing: border-box;
  border-radius: 6px;
  font-family: 'inter';
}
.dialog-container {
  .dialog-header {
    padding: 16px;
    background: #F6F8FA;
    border-bottom: 1px solid #E1E4E8;
    border-radius: 6px 6px 0 0;
    span{
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      display: flex;
      align-items: center;
      color: #1B1F23;
      flex: none;
      order: 0;
      align-self: stretch;
      flex-grow: 0;
      /*margin: 10px 0px;*/
    }
  }
  .dialog-body{
    padding: 20px 15px;
    /deep/.el-radio-group{
      width: 100%;
    .el-radio{
        padding:20px;
        margin-top: 20px;
        background: #FAFBFC;
        border-radius: 6px;
      display: flex;
      align-items: center;
      .el-radio__label{
        flex: 1;
      }
      }
    }

  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    .col{
      width: 100%;
      .el-button{
        margin-left: 0;
      }
      .mg-b-20{
        margin-bottom: 20px;
      }
    }
  }
  .doc-tips {
    display: block;
    margin: 5px 0;
    font-size: 14px;
    font-weight: 400;
    color: $dark;
  }
  .name-content {
    border: 1px solid #E1E4E8;
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    text-align: center;
    text-decoration-skip-ink: none;
    height: 18px;
    padding: 1px 8px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .mg-l-4 {
    margin-left: 4px;
  }
}

</style>
